export default function Search({ className }) {
    return (
      <svg className={className} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.95488 10.9098C8.69138 10.9098 10.9098 8.69138 10.9098 5.95488C10.9098 3.21837 8.69138 1 5.95488 1C3.21837 1 1 3.21837 1 5.95488C1 8.69138 3.21837 10.9098 5.95488 10.9098Z"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeMiterlimit="10" />
        <path d="M13.0014 13.0004L9.45898 9.45801"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round" />
      </svg>
    )
}
